import { IRegion } from '../../../types/geoSwitcher';
import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRegionSucceed, EGetRegionActionTypes } from './types';

export const getRegionSucceed: (region: IRegion) => TGetRegionSucceed = actionGenerator<
  EGetRegionActionTypes.Succeed,
  IRegion
>(EGetRegionActionTypes.Succeed);
